import React from "react";

const CONNECTOR_META = {
  gmail: {
    label: "Gmail",
    hint: "So the AI can search recent threads and save the draft to your mailbox. Nothing is sent automatically.",
    connectLabel: "Connect Gmail",
    connectingLabel: "Connecting to Gmail…",
    skipLabel: "Skip — draft without email history",
  },
  calendar: {
    label: "Google Calendar",
    hint: "So meeting-time suggestions match your real availability, instead of default hours.",
    connectLabel: "Connect Google Calendar",
    connectingLabel: "Connecting to Calendar…",
    skipLabel: "Skip — suggest times without my calendar",
  },
  attio: {
    label: "Attio",
    hint: "So the AI can write this CRM note or task directly to Attio.",
    connectLabel: "Connect Attio",
    connectingLabel: "Connecting to Attio…",
    skipLabel: "Skip — prepare the update without writing it",
  },
};

/**
 * Pre-run Connect/Skip modal for whichever connectors an AI run still needs
 * a choice for. Purely presentational — `useConnectorRunGate` owns state.
 *
 * @example
 * <ConnectorRunGateModal
 *   pendingConnectors={["gmail"]}
 *   loadingConnectorId={null}
 *   onConnect={(id) => {}}
 *   onSkip={(id) => {}}
 *   onDismiss={() => {}}
 * />
 */
const ConnectorRunGateModal = ({
  pendingConnectors,
  loadingConnectorId,
  onConnect,
  onSkip,
  onDismiss,
}) => {
  return (
    <>
      <div className="performer-overlay-backdrop" onClick={onDismiss} />
      <div className="performer-overlay" role="dialog" aria-modal="true">
        <div className="performer-overlay__head">
          <div className="performer-overlay__icon">✦</div>
          <div className="performer-overlay__titles">
            <h3 className="performer-overlay__title">Connect your tools</h3>
            <p className="performer-overlay__subtitle">
              The AI works best with these connected — or skip and it'll still draft your best guess.
            </p>
          </div>
          <button
            type="button"
            className="performer-overlay__close"
            onClick={onDismiss}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="performer-overlay__body">
          {pendingConnectors.map((id) => {
            const meta = CONNECTOR_META[id];
            if (!meta) return null;
            const isLoading = loadingConnectorId === id;
            return (
              <div className="performer-overlay__connector-row" key={id}>
                <div className="performer-overlay__connector-copy">
                  <span className="performer-overlay__connector-name">{meta.label}</span>
                  <span className="performer-overlay__connector-hint">{meta.hint}</span>
                </div>
                <div className="performer-overlay__actions">
                  <button
                    type="button"
                    className="performer-overlay__primary-btn"
                    onClick={() => onConnect(id)}
                    disabled={Boolean(loadingConnectorId)}
                    aria-busy={isLoading}
                  >
                    {isLoading ? meta.connectingLabel : meta.connectLabel}
                  </button>
                  <button
                    type="button"
                    className="performer-overlay__secondary-btn"
                    onClick={() => onSkip(id)}
                    disabled={Boolean(loadingConnectorId)}
                  >
                    {meta.skipLabel}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ConnectorRunGateModal;
